import { PROPERTY_ASSET_TYPES } from "@loanbossinc/component-library";
import { isContainedInList } from "helpers/row-logic-helper";

export const shouldShowUnits = data => isContainedInList(data, "assetTypeId", [
  PROPERTY_ASSET_TYPES.MULTIFAMILY,
  PROPERTY_ASSET_TYPES.SINGLE_FAMILY_RESIDENTIAL,
  PROPERTY_ASSET_TYPES.AGRICULTURE,
  PROPERTY_ASSET_TYPES.OPERATING_COMPANY,
  PROPERTY_ASSET_TYPES.SELF_STORAGE,
  PROPERTY_ASSET_TYPES.NOT_APPLICABLE
]);

export const shouldShowSquareFeet = data => isContainedInList(data, "assetTypeId", [
  PROPERTY_ASSET_TYPES.CONDO,
  PROPERTY_ASSET_TYPES.DATA_CENTER,
  PROPERTY_ASSET_TYPES.FLEX,
  PROPERTY_ASSET_TYPES.INDUSTRIAL,
  PROPERTY_ASSET_TYPES.LAND,
  PROPERTY_ASSET_TYPES.MEDICAL,
  PROPERTY_ASSET_TYPES.MIXED_USE,
  PROPERTY_ASSET_TYPES.OFFICE,
  PROPERTY_ASSET_TYPES.OTHER,
  PROPERTY_ASSET_TYPES.RESIDENTIAL,
  PROPERTY_ASSET_TYPES.RETAIL,
  PROPERTY_ASSET_TYPES.SENIOR_LIVING,
  PROPERTY_ASSET_TYPES.STUDENT_HOUSING,
  PROPERTY_ASSET_TYPES.SINGLE_FAMILY_RESIDENTIAL,
  PROPERTY_ASSET_TYPES.AGRICULTURE,
  PROPERTY_ASSET_TYPES.OPERATING_COMPANY,
  PROPERTY_ASSET_TYPES.SELF_STORAGE,
  PROPERTY_ASSET_TYPES.NOT_APPLICABLE
]);

export const shouldShowHotelRooms = data => isContainedInList(data, "assetTypeId", [
  PROPERTY_ASSET_TYPES.HOTEL
]);
